// The Next mentors table carried this helper inline. It keeps the stored casing, unlike
// `githubHandle` in lib/utils.
export function githubUsername(url: string): string {
  return url.replace(/^https?:\/\/(www\.)?github\.com\//, '').replace(/\/$/, '');
}
